import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function BotDistribution({ botData }) {
  const data = {
    labels: botData.map(item => item.strategy),
    datasets: [
      {
        label: 'Active Bots',
        data: botData.map(item => item.active),
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
      {
        label: 'Inactive Bots',
        data: botData.map(item => item.inactive),
        backgroundColor: 'rgba(211, 211, 211, 0.6)',
        borderColor: 'rgba(211, 211, 211, 1)',
        borderWidth: 1,
      }
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Bot Distribution by Strategy'
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Number of Bots'
        }
      },
      x: {
        title: {
          display: true,
          text: 'Strategy Type'
        }
      }
    }
  };

  return (
    <div className="h-80">
      <Bar data={data} options={options} />
    </div>
  );
}
